import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SezionaliProps } from 'src/app/entities/various';
import { LoginService, UserData } from 'src/app/services/login/login.service';
import { UserService } from 'src/app/services/users/user.service';

@Component({
  selector: 'app-sezionali-disponibili',
  templateUrl: './sezionali-disponibili.component.html',
  styleUrls: ['./sezionali-disponibili.component.css']
})
export class SezionaliDisponibiliComponent implements OnInit {

  constructor(public translate: TranslateService, public activeModal: NgbActiveModal, private loginService: LoginService, private userService: UserService) { }

  loading : boolean = false;
  first: boolean = true;
  listSezionali : SezionaliProps[] | undefined;

  @Input() alreadyLoadedSezionali : SezionaliProps[] | undefined;

  firstLoading: boolean = true;
  async ngOnInit() {
    //let userInfo = await this.loginService.getSessionUserInfo();
    let userInfo: UserData = JSON.parse(localStorage.getItem("einvuser") || "");
    if(this.alreadyLoadedSezionali != undefined){
      this.listSezionali=this.alreadyLoadedSezionali;
    }else{
        let response = await this.userService.getSezionali(userInfo!.user_id);
        if(response.success){
          this.listSezionali = response.data as SezionaliProps[];
        }
        if(this.listSezionali == undefined || this.listSezionali.length == 0){
          this.activeModal.close([]);
        }
    }
    this.firstLoading = false;
  }

  public selectOne(doc: SezionaliProps){
    if(doc.selected){
      this.listSezionali!.filter(d => d.id != doc.id).forEach(d => d.selected = false);
    }
  }

  close(){
    this.activeModal.close(null);
  }

  public save(){
    if(this.listSezionali!.filter(d => d.selected).length > 0){
      this.activeModal.close(this.listSezionali!.filter(d => d.selected)[0]);
    } else {
      this.activeModal.close(null);
    }
  }
}
